import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { FieldArray, Form, Formik } from "formik";
import ContactsAndAddresses from "../ContactsComponents/ContactsModals/ContactsAndAddresses";
import SalesAndPurchases from "../ContactsComponents/ContactsModals/SalesAndPurchases";
import Invoicing from "../ContactsComponents/ContactsModals/Invoicing";
import PartnerAssignment from "../ContactsComponents/ContactsModals/PartnerAssignment";
import { useSession } from "../../authentications/SessionContext";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import LoaderWrapper from "../Loader/LoaderWrapper";
import FormikInput from "../Formik/FormikInput";
import FormikSelect from "../Formik/FormikSelect";
import cameraIcon from "../../Images/camera.svg";
import ErrorFocus from "../Formik/ErrorFocus";
import InternalNotes from "./ContactsModals/InternalNotes";
import useListOptions from "../../CustomHooks/useListOptions";
import editIcon from "../../Images/edit.svg";
import { onChangeSelectContact } from "../../DataApi/contacts/onchangeSelectContact";
import { countryChangeDefaultValues } from "../../utilities/Validation Schema/onChangeDefaultOptions";
import { findAndAddOption } from "../../utilities/findAndAddOption";
import { createGeneral } from "../../DataApi/generalApis/createGeneral";
import UploadedImage from "../UploadedImagedComponent/UploadedImage";
import { fileToBase64 } from "../../utilities/fileToBase64";
import { getFormattedList } from "../../utilities/getFormtattedList";
import useConfirmationModal from "../ConfirmationModal/useConfirmationModal";
import { read } from "../../DataApi/read";
import {
  CONTACT_DETAIL_FIELDS_LIST,
  CREATE_NEW_CONTACT_COMPANY_TYPE,
  CREATE_NEW_CONTACT_RADIO_OPTIONS,
  ONCHANGE_CONTACT_COMPANY_FIELDS,
} from "../../utilities/constants";
import { write } from "../../DataApi/write";
import { onChangeGeneral } from "../../DataApi/generalApis/onChangeGeneral";
import SVGButton from "../Buttons/SVGButton";
import { addContactFromValidationSchema } from "../../utilities/Validation Schema/contactFormValidation";
import { FormContainer } from "../StyledComponents/FormConatiner/FormContainerStyle";
import useFormikSubmitButton from "../../CustomHooks/useFormikSubmitButton";
import { handleResponse } from "../../utilities/handleResponse";

const Button = styled.button`
  background-color: #cbcbcb;
  color: #535559;
  width: 280px;
  min-width: 160px;
  border: none;
  border-radius: 15px;
  padding: 10px 20px;
  font-family: "Inter";
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;

  &:hover,
  &:focus,
  &:active {
    background-color: #ff5837;
    color: #fff;
  }
`;
const ImageContainer = styled.div`
  max-width: 200px;
  border-radius: 10px;
  background-color: #f5f5f5;
  border: 1px solid #cbcbcb;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 193px;
  height: 195px;
`;
const initialValues = {
  name: false,
  title: false,
  parent_id: false,
  child_ids: [],
  ref: false,
  lang: "en_US",
  vat: false,
  same_vat_partner_id: false,
  bank_ids: [],
  website: false,
  comment: false,
  category_id: [],
  active: true,
  function: false,
  type: "contact",
  street: false,
  street2: false,
  zip: false,
  city: false,
  state_id: false,
  country_id: false,
  mobile: false,
  is_company: true,
  industry_id: false,
  company_type: "person",
  company_id: false,
  user_ids: [],
  commercial_partner_id: false,
  company_name: false,
  barcode: false,
  activity_ids: [],
  message_follower_ids: [],
  message_ids: [],
  is_blacklisted: false,
  email: false,
  phone: false,
  user_id: false,
  phone_sanitized: false,
  phone_blacklisted: false,
  mobile_blacklisted: false,
  // partner_gid: false,
  // additional_info: false,
  total_invoiced: false,
  currency_id: false,
  property_account_payable_id: false,
  property_account_receivable_id: false,
  property_account_position_id: false,
  property_payment_term_id: false,
  property_supplier_payment_term_id: false,
  invoice_warn: "no-message",
  invoice_warn_msg: false,
  team_id: false,
  opportunity_count: false,
  meeting_count: false,
  property_stock_customer: false,
  property_stock_supplier: false,
  picking_warn: "no-message",
  picking_warn_msg: false,
  website_id: false,
  property_payment_method_id: false,
  payment_token_count: false,
  pos_order_count: false,
  sale_order_count: false,
  sale_warn: "no-message",
  sale_warn_msg: false,
  warning_stage: false,
  blocking_stage: false,
  active_limit: false,
  enable_credit_limit: false,
  property_delivery_carrier_id: false,
  property_product_pricelist: false,
  image_1920: false,
  additionalOptions: {},
};
const AddNewContact = ({ handleCloseModal, selectedRecord }) => {
  const { sessionInfo } = useSession();
  const { company_id, context } = sessionInfo;

  const { language, translations } = useLanguage();
  const t = translations[language];

  // custom hooks
  const {
    toggleModal,
    ConfirmationModal: ErrorDisplayModal,
    setTitle,
    setMetaData,
  } = useConfirmationModal();
  const { setIsSubmitting, FormikSubmitButtons } = useFormikSubmitButton();

  const {
    options: stateList,
    setOptions: setStateList,
    handleCustomSearch,
  } = useListOptions();

  const [previousInputs, setPreviousInputs] = useState({});
  const image1920Ref = useRef();
  const [activeTab, setActiveTab] = useState(1);
  const [modalType, setModalType] = useState("view");
  const [counryList, setCounryList] = useState([]);
  const [categortList, setCategortList] = useState([]);
  const [websiteList, setWebsiteList] = useState([]);
  const [industryList, setIndustryList] = useState([]);
  const [paymentTermsList, setPaymentTermsList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [formData, setFormData] = useState(initialValues);
  const [contactIncommingOptions, setContactIncommingOptions] = useState([]);
  const [fiscalInformationList, setFiscalInformationList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  const handleNext = (e) => {
    e.preventDefault();
    setActiveTab(activeTab + 1);
  };
  const handleNavigationItemClick = (tabIndex, e) => {
    e.preventDefault(); // Prevent default behavior
    e.stopPropagation();
    setActiveTab(tabIndex);
  };

  const handleChangeCompanyType = (e, setFieldValue) => {
    const { name, value } = e.target;
    setFieldValue(name, value);

    setFieldValue("is_company", value === "company");
    setFieldValue("parent_id", value === "company" ? false : company_id);
  };

  const handleChangeimage1920 = (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      fileToBase64(file, (_, base64) => setFieldValue("image_1920", base64));
    }
  };
  const handleChangeCountry = async (
    option,
    { name },
    values,
    setFieldValue
  ) => {
    const response = await onChangeSelectContact({
      company_id,
      context,
      keyChange: "country_id",
      values: { ...values, name: option.value },
      model: "res.partner",
      defaulChange: countryChangeDefaultValues,
    });
    findAndAddOption({
      availableOptions: counryList,
      incomingOption: [option.value, option.label],
      setAvailableOptions: setCounryList,
    });
    const incomingValues = response?.result?.value || {};
    Object.keys(incomingValues)?.forEach((key) => {
      setFieldValue(key, incomingValues[key]);
    });
    handleCustomSearch({
      model: "res.country.state",
      args: [["country_id", "=?", option.value]],
      setState: setStateList,
    });
  };

  const getPayload = (payload) => {
    const childIds = getFormattedList(payload?.child_ids || [], "id", [
      "isDeleted",
      "state",
      "country",
      "street1",
    ]);
    const newPayload = {
      name: payload?.name || false,
      title: payload?.title || false,
      parent_id: payload?.parent_id || false,
      child_ids: childIds || [],
      ref: payload?.ref || false,
      lang: payload?.lang || "en_US",
      vat: payload?.vat || false,
      same_vat_partner_id: payload?.same_vat_partner_id || false,
      bank_ids: payload?.bank_ids || [],
      website: payload?.website || false,
      comment: payload?.comment || false,
      category_id: [[6, false, payload?.category_id || []]],
      active: payload?.active || true,
      function: payload?.function || false,
      type: payload?.type || "contact",
      street: payload?.street || false,
      street2: payload?.street2 || false,
      zip: payload?.zip || false,
      city: payload?.city || false,
      state_id: payload?.state_id || false,
      country_id: payload?.country_id || false,
      mobile: payload?.mobile || false,
      is_company: payload?.is_company || true,
      industry_id: payload?.industry_id || false,
      company_type: payload?.company_type || "company",
      company_id: payload?.company_id || company_id,
      user_ids: payload?.user_ids || [],
      commercial_partner_id: payload?.commercial_partner_id || false,
      company_name: payload?.company_name || false,
      barcode: payload?.barcode || false,
      activity_ids: payload?.activity_ids || [],
      message_follower_ids: payload?.message_follower_ids || [],
      message_ids: payload?.message_ids || [],
      is_blacklisted: payload?.is_blacklisted || false,
      email: payload?.email || false,
      phone: payload?.phone || false,
      user_id: payload?.user_id || false,
      phone_sanitized: payload?.phone_sanitized || false,
      phone_blacklisted: payload?.phone_blacklisted || false,
      mobile_blacklisted: payload?.mobile_blacklisted || false,
      // partner_gid: payload?.partner_gid || false,
      // additional_info: payload?.additional_info || false,
      total_invoiced: payload?.total_invoiced || false,
      currency_id: payload?.currency_id || false,
      property_account_payable_id:
        payload?.property_account_payable_id || false,
      property_account_receivable_id:
        payload?.property_account_receivable_id || false,
      property_account_position_id:
        payload?.property_account_position_id || false,
      property_payment_term_id: payload?.property_payment_term_id || false,
      property_supplier_payment_term_id:
        payload?.property_supplier_payment_term_id || false,
      invoice_warn: payload?.invoice_warn || "no-message",
      invoice_warn_msg: payload?.invoice_warn_msg || false,
      team_id: payload?.team_id || false,
      opportunity_count: payload?.opportunity_count || false,
      meeting_count: payload?.meeting_count || false,
      property_stock_customer: payload?.property_stock_customer || false,
      property_stock_supplier: payload?.property_stock_supplier || false,
      picking_warn: payload?.picking_warn || "no-message",
      picking_warn_msg: payload?.picking_warn_msg || false,
      website_id: payload?.website_id || false,
      property_payment_method_id: payload?.property_payment_method_id || false,
      payment_token_count: payload?.payment_token_count || false,
      pos_order_count: payload?.pos_order_count || false,
      sale_order_count: payload?.sale_order_count || false,
      sale_warn: payload?.sale_warn || "no-message",
      sale_warn_msg: payload?.sale_warn_msg || false,
      warning_stage: payload?.warning_stage || false,
      blocking_stage: payload?.blocking_stage || false,
      active_limit: payload?.active_limit || false,
      enable_credit_limit: payload?.enable_credit_limit || false,
      property_delivery_carrier_id:
        payload?.property_delivery_carrier_id || false,
      property_product_pricelist: payload?.property_product_pricelist || false,
      image_1920: payload?.image_1920 || false,
    };
    return newPayload;
  };

  const handleAddContact = async (values) => {
    const payload = getPayload(values);

    // return
    const response = await createGeneral({
      model: "res.partner",
      context,
      // kwargs:,
      payload: payload,
    });
    if (response.result) {
      handleCloseModal();
    }
    return response;
  };
  const handleEditContact = async (values) => {
    const newChanges = {};
    const newPayload = getPayload(values);
    const oldPayload = getPayload(previousInputs);

    Object.keys(newPayload).forEach((key) => {
      if (JSON.stringify(newPayload[key]) !== JSON.stringify(oldPayload[key])) {
        newChanges[key] = newPayload[key];
      }
    });
    if (Object.keys(newChanges)?.length === 0) {
      handleCloseModal();
      return false;
    }
    // return
    let response = await write({
      change: newChanges,
      company_id,
      context,
      id: selectedRecord.id,
      model: "res.partner",
    });
    response = JSON.parse(response);
    if (response.result) {
      handleCloseModal();
    }
    return response;
  };
  const handleSubmitForm = async (...args) => {
    setIsSubmitting(true);
    let successMessage = "Contact Created Successfully";
    let response = null;
    if (selectedRecord?.id) {
      successMessage = "Contact Editted Successfully";

      response = await handleEditContact(...args);
    } else {
      response = await handleAddContact(...args);
    }
    setIsSubmitting(false);
    handleResponse({
      response,
      setMetaData,
      setTitle,
      successMessage,
    });
  };

  const getIncomingOptionsList = (incomingOptions, key, data) => {
    const { [key]: option = false } = data;
    if (option)
      incomingOptions[key].add({
        label: option?.[1],
        value: option[0],
      });
  };
  const getChildResponse = async (childIds, incomingOptions) => {
    let childIdsResponse = await read({
      company_id,
      context,
      model: "res.partner",
      id: childIds,
      change: CONTACT_DETAIL_FIELDS_LIST,
    });
    childIdsResponse = JSON.parse(childIdsResponse);
    childIdsResponse = childIdsResponse?.result;

    setContactIncommingOptions(incomingOptions);
    return childIdsResponse.map((contact) => {
      const { state_id = false, country_id = false, title = false } = contact;
      getIncomingOptionsList(incomingOptions, "state_id", contact);
      getIncomingOptionsList(incomingOptions, "country_id", contact);
      getIncomingOptionsList(incomingOptions, "title", contact);
      return {
        ...contact,
        isDeleted: false,
        country_id: country_id[0],
        state_id: state_id[0],
        title: title[0],
      };
    });
  };

  const handleChangeCompany = async (option, values, setFieldValue) => {
    findAndAddOption({
      availableOptions: companyList,
      incomingOption: [option.value, option.label],
      setAvailableOptions: setCompanyList,
    });
    const { country_id, state_id, street, street2, city, zip } = values;
    let companyChangeResponse = await onChangeGeneral({
      company_id,
      model: "res.partner",
      context,
      args: {
        id: selectedRecord?.id || [],
        values: {
          country_id,
          state_id,
          street,
          street2,
          city,
          zip,
          parent_id: option.value,
        },
        keyChange: ["parent_id"],
        defaulChange: ONCHANGE_CONTACT_COMPANY_FIELDS,
      },
    });
    companyChangeResponse = companyChangeResponse?.result?.value || {};
    const warning = companyChangeResponse?.result?.warning || null;

    if (Object.keys(companyChangeResponse).length > 0) {
      const { zip, street, street2, country_id, state_id, city } =
        companyChangeResponse;
      setFieldValue("city", city);
      setFieldValue("street", street);
      setFieldValue("street2", street2);
      setFieldValue("zip", zip);
      findAndAddOption({
        availableOptions: stateList,
        incomingOption: state_id,
        setAvailableOptions: setStateList,
        keyName: "state_id",
        setFieldValue,
      });
      findAndAddOption({
        availableOptions: counryList,
        incomingOption: country_id,
        setAvailableOptions: setCounryList,
        keyName: "country_id",
        setFieldValue,
      });
    }
  };

  const handleCountryOptions = ({ ...args }) => {
    return handleCustomSearch({
      ...args,
      model: "res.partner",
      args: [["is_company", "=", true]],
    });
  };
  const fetchContactDetail = async () => {
    if (selectedRecord?.id) {
      setModalType("view");
      let contactResponse = await read({
        company_id,
        context,
        model: "res.partner",
        id: selectedRecord.id,
        change: CONTACT_DETAIL_FIELDS_LIST,
      });
      contactResponse = JSON.parse(contactResponse);
      if (contactResponse?.result) {
        let childIdsResponse = [];
        let incomingOptions = {
          state_id: new Set(),
          title: new Set(),
          country_id: new Set(),
          parent_id: new Set(),
        };
        if (contactResponse?.result?.[0].child_ids) {
          childIdsResponse = await getChildResponse(
            contactResponse?.result[0]?.child_ids,
            incomingOptions
          );
        }

        contactResponse = contactResponse?.result?.[0];
        const ContactDetails = {
          ...contactResponse,
          country_id: contactResponse?.country_id[0],
          state_id: contactResponse?.state_id[0],
          website_id: contactResponse?.website_id[0],
          parent_id: contactResponse?.parent_id[0],
          property_supplier_payment_term_id:
            contactResponse?.property_supplier_payment_term_id[0],
          industry_id: contactResponse?.industry_id[0],
          property_account_position_id:
            contactResponse?.property_account_position_id?.[0] || "",
          child_ids: childIdsResponse,
          additionalOptions: {
            country: contactResponse?.country_id || "",
            state: contactResponse?.state_id || "",
            website: contactResponse?.website_id || "",
            parent: contactResponse?.parent_id || "",
            property_supplier_payment_term:
              contactResponse?.property_supplier_payment_term_id || "",
            industry: contactResponse?.industry_id || "",
            property_account_position_id:
              contactResponse?.property_account_position || [],
          },
        };
        setFormData({ ...ContactDetails });
        setPreviousInputs({ ...ContactDetails });
        return ContactDetails;
      }
      return false;
    }
    setModalType("add");
    return false;
  };

  useEffect(() => {
    fetchContactDetail().then((response) => {
      setIsLoading(false);
      if (!response) return;
      const {
        country,
        industry,
        parent,
        property_supplier_payment_term,
        state,
        website,
        // property_account_position_id,
      } = response.additionalOptions;
      findAndAddOption({
        incomingOption: country,
        availableOptions: counryList,
        setAvailableOptions: setCounryList,
      });
      findAndAddOption({
        incomingOption: property_supplier_payment_term,
        availableOptions: paymentTermsList,
        setAvailableOptions: setPaymentTermsList,
      });
      findAndAddOption({
        incomingOption: industry,
        availableOptions: industryList,
        setAvailableOptions: setIndustryList,
      });
      findAndAddOption({
        incomingOption: parent,
        availableOptions: companyList,
        setAvailableOptions: setCompanyList,
      });

      findAndAddOption({
        incomingOption: state,
        availableOptions: stateList,
        setAvailableOptions: setStateList,
      });
      findAndAddOption({
        incomingOption: website,
        availableOptions: websiteList,
        setAvailableOptions: setWebsiteList,
      });
    });
    handleCustomSearch({
      model: "res.partner.category",
      setState: setCategortList,
    });
  }, []);

  useEffect(() => {
    if (modalType === "add" || (modalType === "edit" && selectedRecord.id)) {
      const {
        country,
        industry,
        parent,
        property_supplier_payment_term,
        state,
        website,
        property_account_position_id,
      } = formData.additionalOptions;
      handleCustomSearch({
        model: "res.country.state",
        setState: setStateList,
        staticOptions: state ? [state] : [],
      });
      handleCustomSearch({
        model: "res.country",
        setState: setCounryList,
        staticOptions: country ? [country] : [],
      });
      handleCustomSearch({
        model: "account.payment.term",
        setState: setPaymentTermsList,
        staticOptions: property_supplier_payment_term
          ? [property_supplier_payment_term]
          : [],
      });

      handleCustomSearch({
        model: "res.partner.industry",
        setState: setIndustryList,
        staticOptions: industry ? [industry] : [],
      });
      handleCustomSearch({
        model: "website",
        setState: setWebsiteList,
        staticOptions: website ? [website] : [],
      });
      // handleCustomSearch({
      //   model: "res.bank",
      //   setState: setBankList,
      //   // staticOptions: bank ? [bank] : [],
      // });
      handleCustomSearch({
        model: "account.fiscal.position",
        setState: setFiscalInformationList,
        args: [["company_id", "=", company_id]],
        staticOptions: property_account_position_id
          ? [property_account_position_id]
          : [],
      });
      handleCountryOptions({
        setState: setCompanyList,
        staticOptions: parent ? [parent] : [],
      });
    }
  }, [modalType, selectedRecord]);

  const disableInputs = useMemo(() => modalType === "view", [modalType]);
  return (
    <>
      <ErrorDisplayModal />
      <Formik
        enableReinitialize
        initialValues={formData}
        validationSchema={addContactFromValidationSchema}
        onSubmit={handleSubmitForm}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <div
              className="container"
              style={{ maxWidth: "900px", padding: "10px", paddingTop: 0 }}
            >
              <FormContainer className="row g-3">
                <div className="d-flex">
                  <h3 className="modal-title ">
                    {modalType === "add" && t["Add Contact"]}
                    {modalType === "edit" && t["Edit Contact"]}
                    {modalType === "view" && t["Contact"]}
                  </h3>
                  {modalType === "view" && (
                    <div className="col d-flex justify-content-end p-0">
                      <SVGButton
                        icon={editIcon}
                        onClick={() => {
                          setModalType("edit");
                        }}
                        className="me-2"
                      />
                    </div>
                  )}
                </div>
                <hr />
                <LoaderWrapper isLoading={isLoading} height="70vh" width="100%">
                  <div className="row p-0 justify-content-between align-items-center">
                    <div className="d-flex  flex-column flex-md-row justify-content-between">
                      <div className="d-flex flex-column mb-3 col-12 col-md-8">
                        <div className="d-flex mt-2 mb-2">
                          {CREATE_NEW_CONTACT_COMPANY_TYPE.map((radio) => (
                            <div key={radio.value}>
                              <input
                                type="radio"
                                id={radio.value}
                                disabled={disableInputs}
                                value={radio.value}
                                checked={radio.value === values.company_type}
                                name="company_type"
                                className=" ms-2 radio_input"
                                onChange={(e) =>
                                  handleChangeCompanyType(e, setFieldValue)
                                }
                              />
                              <label htmlFor={radio.value} className="ms-2">
                                {t[radio.label]}
                              </label>
                            </div>
                          ))}
                        </div>
                        <div>
                          <div className="col-12">
                            <FormikInput
                              disabled={disableInputs}
                              label={t["Name"]}
                              name="name"
                            />
                          </div>
                          {values.company_type === "person" && (
                            <div className="col-12">
                              <FormikSelect
                                options={companyList}
                                disabled={disableInputs}
                                name="parent_id"
                                label={t["Company"]}
                                handleSearch={handleCountryOptions}
                                onChange={(option) =>
                                  handleChangeCompany(
                                    option,
                                    values,
                                    setFieldValue
                                  )
                                }
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <ImageContainer
                        onClick={() => {
                          if (!disableInputs) image1920Ref.current.click();
                        }}
                        className="ms-4"
                      >
                        <UploadedImage src={values.image_1920 || cameraIcon} />
                        <input
                          ref={image1920Ref}
                          type="file"
                          name="image_1920"
                          hidden
                          accept="image/*"
                          onChange={(e) =>
                            handleChangeimage1920(e, setFieldValue)
                          }
                        />
                      </ImageContainer>
                    </div>
                    <hr />
                  </div>

                  <h5
                    className="me-2 mb-2 "
                    style={{
                      fontFamily: "Inter",
                      color: "#323B4B",
                      fontWeight: 600,
                    }}
                  >
                    {t["Address"]}
                  </h5>
                  {values.company_type === "person" && (
                    <div className="col-12">
                      <div className="col-md-4">
                        <FormikSelect
                          options={CREATE_NEW_CONTACT_RADIO_OPTIONS}
                          disabled={disableInputs}
                          name="type"
                          label={t["Address Type"]}
                        />
                      </div>
                    </div>
                  )}
                  {values.type !== "contact" && (
                    <>
                      <div className="col-md-6">
                        <FormikInput
                          name="street"
                          disabled={disableInputs}
                          placeholder={t["Street"]}
                        />
                      </div>
                      <div className="col-md-6">
                        <FormikInput
                          name="street2"
                          disabled={disableInputs}
                          placeholder={t["Town"]}
                        />
                      </div>

                      <div className="col-md-3">
                        <FormikSelect
                          name="country_id"
                          options={counryList}
                          disabled={disableInputs}
                          placeholder={t["Country"]}
                          handleSearch={({ ...args }) =>
                            handleCustomSearch({
                              ...args,
                              model: "res.country",
                            })
                          }
                          onChange={(option, event) => {
                            handleChangeCountry(
                              option,
                              event,
                              values,
                              setFieldValue
                            );
                          }}
                        />
                      </div>
                      <div className="col-md-3">
                        <FormikSelect
                          name="state_id"
                          options={stateList}
                          placeholder={t["State"]}
                          disabled={disableInputs}
                          handleSearch={({ ...args }) =>
                            handleCustomSearch({
                              ...args,
                              model: "res.country.state",
                              args: values.country_id
                                ? [["country_id", "=?", values.country_id]]
                                : [],
                            })
                          }
                        />
                      </div>
                      <div className="col-md-3">
                        <FormikInput
                          disabled={disableInputs}
                          name="city"
                          placeholder={t["City"]}
                        />
                      </div>
                      <div className="col-md-3">
                        <FormikInput
                          disabled={disableInputs}
                          name="zip"
                          placeholder={t["Zip"]}
                        />
                      </div>
                      <hr />
                    </>
                  )}
                  <div className="col-md-4">
                    <FormikInput
                      disabled={disableInputs}
                      label={t["Phone"]}
                      name="phone"
                    />
                  </div>
                  <div className="col-md-4">
                    <FormikInput
                      disabled={disableInputs}
                      label={t["Mobile"]}
                      name="mobile"
                    />
                  </div>
                  <div className="col-md-4">
                    {/* <StyledLabel
                    htmlFor="inputPassword4"
                    className="form-label"
                    defaultValue=""
                  >
                    {t["Email"]}
                  </StyledLabel> */}
                    <FormikInput
                      disabled={disableInputs}
                      label={t["Email"]}
                      name="email"
                    />
                  </div>
                  <div className="col-md-4">
                    <FormikInput
                      disabled={disableInputs}
                      label={t["Website Link"]}
                      name="website"
                    />
                  </div>

                  <div className="col-md-4">
                    <FormikSelect
                      name="category_id"
                      label={t["Tags"]}
                      isMulti
                      disabled={disableInputs}
                      options={categortList}
                    />
                  </div>

                  <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                      {/* <button
                      className={`nav-link ${activeTab === 0 ? "active" : ""}`}
                      onClick={(e) => handleNavigationItemClick(0, e)}
                    >
                      {t["Bank Account and CR"]}
                    </button> */}
                      <button
                        className={`nav-link ${
                          activeTab === 1 ? "active" : ""
                        }`}
                        onClick={(e) => handleNavigationItemClick(1, e)}
                      >
                        {t["Contacts and Addresses"]}
                      </button>
                      <button
                        className={`nav-link ${
                          activeTab === 2 ? "active" : ""
                        }`}
                        onClick={(e) => handleNavigationItemClick(2, e)}
                      >
                        {t["Sales and Purchases"]}
                      </button>
                      {/* <button
                      className={`nav-link ${activeTab === 3 ? "active" : ""}`}
                      onClick={(e) => handleNavigationItemClick(3, e)}
                    >
                      {t["Invoicing"]}
                    </button>
                    <button
                      className={`nav-link ${activeTab === 4 ? "active" : ""}`}
                      onClick={(e) => handleNavigationItemClick(4, e)}
                    >
                      {t["Internal Notes"]}
                    </button>
                    <button
                      className={`nav-link ${activeTab === 5 ? "active" : ""}`}
                      onClick={(e) => handleNavigationItemClick(5, e)}
                    >
                      {t["Partner Assignment"]}
                    </button> */}
                    </div>
                  </nav>
                  <div className="tab-content" id="nav-tabContent">
                    <div
                      className={`tab-pane fade overflow-auto show active`}
                      id="nav-home"
                      role="tabpanel"
                      type="button"
                      aria-labelledby="nav-home-tab"
                      tabIndex="0"
                    >
                      {activeTab === 1 && (
                        <FieldArray
                          name="child_ids"
                          render={({ ...props }) => (
                            <ContactsAndAddresses
                              {...props}
                              disabled={disableInputs}
                              formData={formData}
                              contactIncommingOptions={contactIncommingOptions}
                              setContactIncommingOptions={
                                setContactIncommingOptions
                              }
                            />
                          )}
                        />
                      )}
                      {activeTab === 2 && (
                        <SalesAndPurchases
                          disabled={disableInputs}
                          values={values}
                          paymentTermsList={paymentTermsList}
                          websiteList={websiteList}
                          industryList={industryList}
                          fiscalInformationList={fiscalInformationList}
                        />
                      )}

                      {activeTab === 3 && (
                        <Invoicing
                          disabled={disableInputs}
                          formData={formData}
                        />
                      )}
                      {activeTab === 4 && (
                        <InternalNotes
                          disabled={disableInputs}
                          formData={formData}
                        />
                      )}
                      {activeTab == 5 && (
                        <PartnerAssignment
                          disabled={disableInputs}
                          formData={formData}
                        />
                      )}
                    </div>
                  </div>
                  {!disableInputs && (
                    <FormikSubmitButtons handleCloseModal={handleCloseModal} />
                  )}
                </LoaderWrapper>
              </FormContainer>
            </div>
            <ErrorFocus />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddNewContact;
